import React, { useState, useEffect } from 'react';
import { fetchMerchandise, fetchOptions } from '../api/api';
import styles from '../styles/components/_MerchandiseGrid.module.scss';

const MerchandiseGrid = () => {
  const [merchandiseItems, setMerchandiseItems] = useState([]);
  const [merchandiseText, setMerchandiseText] = useState({ titre: '' });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        const [merchandiseData, options] = await Promise.all([
          fetchMerchandise(),
          fetchOptions(),
        ]);

        // Crée un tableau suffisamment long pour éviter de voir la fin
        const minimumItems = 4; // Minimum 3 répétitions
        const repeatedItems = [...Array(minimumItems)]
          .flatMap(() => merchandiseData);

        setMerchandiseItems(repeatedItems);
        if (options?.merchandising) {
          setMerchandiseText(options.merchandising);
        }
        setIsLoading(false);
      } catch (err) {
        console.error('Erreur lors du chargement des données:', err);
        setError('Erreur lors du chargement des données');
        setIsLoading(false);
      }
    };

    loadData();
  }, []);

  if (isLoading) return <div className={styles.loading}>Chargement en cours...</div>;
  if (error) return <div className={styles.error}>{error}</div>;

  return (
    <div className={styles.merchandiseGrid}>
      <h2 className={styles.title}>{merchandiseText.titre || 'Merchandising'}</h2>
      <p className={styles.availability}>En vente sur place ou lors de l'achat de votre billet</p>
      <div className={styles.scrollingContainer}>
        <div className={styles.scrollingContent}>
          {merchandiseItems.map((item, index) => (
            <div key={`${item.id}-${index}`} className={styles.merchandiseItem}>
              <div className={styles.imageContainer}>
                {item.acf?.photo?.[0] && (
                  <img
                    src={item.acf.photo[0].url}
                    alt={item.title?.rendered || 'Article merchandising'}
                    className={styles.image}
                    loading="lazy"
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MerchandiseGrid;
